import { GetAllPeriodicsChecksInDto, GetAllPeriodicsChecksOutDto } from '../../../types/periodic-check.dto'

export const GET_ALL_PERIODICS_CHECKS = 'GET_ALL_PERIODICS_CHECKS'
export const GET_ALL_PERIODICS_CHECKS_SUCCESS = 'GET_ALL_PERIODICS_CHECKS_SUCCESS'
export const GET_ALL_PERIODICS_CHECKS_ERROR = 'GET_ALL_PERIODICS_CHECKS_ERROR'
export const RESET_GET_ALL_PERIODICS_CHECKS = 'RESET_GET_ALL_PERIODICS_CHECKS'

export interface GetAllPeriodicsChecks {
  type: typeof GET_ALL_PERIODICS_CHECKS
  payload: GetAllPeriodicsChecksOutDto
}

export interface GetAllPeriodicsChecksSuccess {
  type: typeof GET_ALL_PERIODICS_CHECKS_SUCCESS
  payload: GetAllPeriodicsChecksInDto
}

export interface GetAllPeriodicsChecksError {
  type: typeof GET_ALL_PERIODICS_CHECKS_ERROR
  payload: string | boolean
}

export interface ResetGetAllPeriodicsChecks {
  type: typeof RESET_GET_ALL_PERIODICS_CHECKS
  payload: null
}

export interface State {
  data: GetAllPeriodicsChecksInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetAllPeriodicsChecks | GetAllPeriodicsChecksSuccess | GetAllPeriodicsChecksError | ResetGetAllPeriodicsChecks
